var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero-section"},[_c('carousel',{staticClass:"hero-items",attrs:{"items":1,"autoplay":true,"nav":true}},[_c('img',{attrs:{"src":"img/home/slideshow/slide1-100.jpg","alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }